<template>
  <div class="register">
    <div v-show="show_qrCode" class="qrCode">
      <h3 class="title">注册互亿编辑器</h3>
      <img
        class="img_code"
        src="http://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQF07zwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAydXNmUTA1a0ljbTMxc3ZwUGhzMU0AAgQPy3NcAwQQDgAA"
      />
      <p>使用微信扫码关注公众号「互亿编辑器」即可注册。</p>
      <a href="####">注册即同意《用户协议》</a>
      <div>已有账号，立即登录</div>
    </div>
    <div v-show="show_fillInInfo" class="fillInInfo">
      <h3>注册成功</h3>
      <p>下次可使用微信扫码 / 手机号码登录</p>
      <div class>继续编辑</div>
    </div>
    <div v-show="show_success" class="success">
      <h3>注册成功</h3>
      <p>下次可使用微信扫码 / 手机号码登录</p>
      <div class>继续编辑</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "comRegister",
  data() {
    return {
      show_qrCode: true,
      show_fillInInfo: false,
      show_success: false
    };
  }
};
</script>

<style lang="scss" scoped>
.register {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;

  .qrCode {
    width: 477px;
    height: 485px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 10px;
  }
  .qrCode .title {
    margin-top: 45px;
  }
  .img_code {
    width: 219px;
    height: 211px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-register.vue